import pkg from '../../package.json';
export const environment = {
  production: false,
  captcha: { enabled: true, widget_url: 'assets/altcha.min.js', challenge_url: '' },
  public_url: 'https://registrator-test.erigo.be',
  api_url: 'https://registrator-test.erigo.be/ipa',
  ping_interval: 60000,
  app_version: pkg.version,
  contact_email: 'registrations@clepa.be',
  invoicing_email: 'invoices@clepa.be'
};


